import { put, select } from 'redux-saga/effects';
import * as actions from '../engine/actions/EditDishActions';
import { sagaCreator, stateSelector } from 'redux-saga-kit';
import { changeCount, createOrderItem, toggleChoice } from '../../utils/DishUtils';
import { hideModal } from '../engine/actions/SessionActions';
import { Modals } from '../../utils/constants';
import BILogger from '../../utils/BILogger';
import _ from 'lodash';

const onNew = () => {
  return function*({ payload }) {
    const { itemId ,availability} = payload;
    const itemsHash = yield select(stateSelector('session.itemsHash'));
    const orderItem = createOrderItem({ itemId, itemsHash, time: 'asap' });
    yield put(actions.startEditing({orderItem: {...orderItem,availability}, origin: 'menuViewer' }));
  };
};

const onChangeCount = () => {
  return function*({ payload }) {
    const { count } = payload;
    const orderItem = yield select(stateSelector('editDish.orderItem'));
    yield put(actions.edit({ orderItem: changeCount({ orderItem, count }) }));
  };
};

const onToggleChoice = () => {
  return function*({ payload }) {
    const { variationPath, choiceId } = payload;
    const orderItem = yield select(stateSelector('editDish.orderItem'));
    const itemsHash = yield select(stateSelector('session.itemsHash'));
    const newOrderItem = toggleChoice({ orderItem, variationPath, choiceId, itemsHash, time: 'asap' });
    yield put(actions.edit({ orderItem: newOrderItem }));
  };
};

const onStartEditing = () => {
  return function*({ payload }) {
    const { orderItem, origin } = payload;
    const { itemId } = orderItem;

    const organizationId = yield select(stateSelector('session.organization.id'));
    const locale = yield select(stateSelector('session.organization.locale'));
    const query = yield select(stateSelector('session.query'));
    const itemsHash = yield select(stateSelector('session.itemsHash'));
    const itemName = itemsHash[itemId].title[locale];

    BILogger.callCenterCartClickOnDish({
      item_id: itemId,
      item_name: itemName,
      organization_id: organizationId,
      origin,
      withFilter: !_.isEmpty(query),
    });
  };
};

const onHideModal = () => {
  return function*({ payload }) {
    if (payload.modal === Modals.EDIT_DISH) {
      yield put(actions.clear());
    }
  };
};

export default sagaCreator({
  [actions.createNew]: { handler: onNew },
  [actions.changeCount]: { handler: onChangeCount },
  [actions.toggleChoice]: { handler: onToggleChoice },
  [actions.startEditing]: { handler: onStartEditing },
  [hideModal]: { handler: onHideModal },
});
